import hljs from "highlight.js/lib/common";

import { wildCart, ShoppingCartTag } from "components/adafruit/wildcart";
import { initMessaging } from "components/adafruit/messaging";

import LearnSearch from 'search/learn';
import PlaygroundSearch from 'search/playground';

import MobileMenu from 'components/adafruit/mobileMenu';
import Dropdown from 'components/dropdown';
import VideoController from 'components/video_controller';
import ContentCards from 'components/content_cards';
import DropdownGuideSearch from 'components/dropdown_guide_search';

new VideoController();

$(function() {
  //only run on first page load
  // new MobileMenu('#small-header');
});

$(document).on('turbo:load', function () {
  // run on every page transition

  if ($("#search-info").length) {
    new LearnSearch();
  }

  if ($("#playground-search-info").length) {
    new PlaygroundSearch();
  }

  new Dropdown();
  new MobileMenu('#small-header');
  new ContentCards();
  
  initMessaging('#messaging-wrapper');

  document.querySelectorAll('pre.prettyprint').forEach(block => {
    hljs.highlightElement(block);
  });

  if ($('.sticky-nav').length > 0) {
    var $nav = $('.sticky-nav');
    var nav_top = $nav.offset().top;
    $nav.before('<div class="nav-bar-placeholder">&nbsp</div>');
    var $placeholder = $('.nav-bar-placeholder');
    $placeholder.height(0);

    $(window).on('scroll', function(){
      var window_top = $(window).scrollTop();

      if (window_top > nav_top) {
        $nav.css({ position: 'fixed', top: "0px", left: "0", right: "0" });
        $placeholder.height($nav.height() + 20);
      } else {
        $nav.css('position','static');
        $placeholder.height(0);
      }
    });
  }

  if(window.devicePixelRatio >= 1.2){
      var elems = document.getElementsByTagName('*');
      for(var i=0;i < elems.length;i++){
          var attr = elems[i].getAttribute('data-2x');
          if(attr && elems[i].tagName == 'IMG'){
              elems[i].src = attr;
          } else if(attr){
              elems[i].style.cssText += 'background-image: url('+attr+')';
          }
      }
  }

var productLinks = document.querySelectorAll('.product-link, .product-buy');

productLinks.forEach(el => el.addEventListener('click', event => {
  var productData = event.target.closest('.product-element, .product-wrapper, .small-product-content-card').querySelector('.product-json').value
  gtag("event", "select_item", JSON.parse(productData));
}));



  if($(".headline-video-group").length) {
    var stream = ""
    if ($(".headline-video-group").data('cid')) {
      stream = "channel_id=" + $(".headline-video-group").data('cid');
    } else {
      stream = "playlist_id=" + $(".headline-video-group").data('playlist-id');
    }
    var reqURL = "https://api.rss2json.com/v1/api.json?rss_url=" + encodeURIComponent("https://www.youtube.com/feeds/videos.xml?" + stream);
    var iframes = document.getElementsByClassName('latestVideoEmbed');

    $.ajax({
      dataType: "json",
      url: reqURL,
      success: function(data) {
        for (var i = 0, len = iframes.length; i < len; i++) {
          var iframe = iframes[i];
          var videoNumber = (iframe.dataset.vnum ? Number(iframe.dataset.vnum) : 0);
          var link = data.items[videoNumber].link;
          var id = link.substr(link.indexOf("=") + 1);
          iframe.setAttribute("src","https://youtube.com/embed/"+ id + "?controls=0&autoplay=0");
          iframe.setAttribute("title", data.items[videoNumber].title);
        }
      }
    });
  }
  const cartLink = document.querySelector(".cart a");
  new ShoppingCartTag(cartLink, {
    wildCart,
    cartUpdated: function (data) {
      var text = "<i class='fa fa-shopping-cart'></i> " + data.cartTotals.items;

      cartLink.innerHTML = text;
    },
  });

  const mobileCartLink = document.querySelector("#mobile-header-cart");
  new ShoppingCartTag(mobileCartLink, {
    wildCart,
    cartUpdated: function (data) {
      var text =
        '<span class="small-cart-count">' +
        data.cartTotals.items +
        '</span> <i class="fa fa-shopping-cart"></i>';

      mobileCartLink.innerHTML = text;
    },
  });

  $('.guide-categories .category, #categories-content .category').on('click', function(event) {
    if ($(this).data("remote") === true) {
      return true;
    }

    //clicking on a category tag, but not for child categories.
    if (!$(this).hasClass('child-category')) {
      event.preventDefault();
      window.location = $('a:last-child', this).attr('href');
    }

  });
}); // end of turbo:load
